// src/pages/admin/adminPageEditor/hooks/useMobileEditorView.js
import { useEffect, useState } from "react";

export function useMobileEditorView(tab) {
  const [mobileEditorView, setMobileEditorView] = useState("controls"); // controls | preview

  useEffect(() => {
    setMobileEditorView("controls");
  }, [tab]);

  return { mobileEditorView, setMobileEditorView };
}